module.exports = __webpack_public_path__ + "2d38e5b941b55699e49a27dad4fec267.woff2";